const paths = {
  Home: '/',

  Dashboard: '/dashboard',

  // Auth
  Auth: '/',
  Login: '/login',
  Signup: '/signup',

  Onboarding: {
    route: '/onboarding',
    children: {
      FirstWorkspaceOnboarding: '/onboarding/workspace-onboarding',
      InvitedUserOnboarding: '/onboarding/invited-user-onboarding',
    },
  },

  Organization: {
    route: '/:orgId',
    children: {
      Decisions: '/:orgId/decisions',
      AllTasks: '/:orgId/all-tasks',
      Space: {
        route: '/:orgId/space/:spaceId',
        children: {
          Backlog: '/:orgId/space/:spaceId/backlog',
          Task: '/:orgId/space/:spaceId/task/:taskId',
          NewSpaceInvite: '/:orgId/space/:spaceId/new-space-invite',
          Planning: {
            route: '/:orgId/space/:spaceId/planning',
            children: {
              PlanningSession: '/:orgId/space/:spaceId/planning/:planningSessionId',
            },
          },
          Iterations: {
            route: '/:orgId/space/:spaceId/sprint',
            children: {
              Iteration: '/:orgId/space/:spaceId/sprint/:iterationId',
            },
          },
          Analytics: '/:orgId/space/:spaceId/analytics',
          Retrospective: {
            route: '/:orgId/space/:spaceId/retrospective',
            children: {
              RetrospectiveSession: '/:orgId/space/:spaceId/retrospective/:retrospectiveSessionId',
            },
          },
        },
      },
      NewSpace: '/:orgId/new-space',
      JoinSpace: '/:orgId/join-space',
      NewOrgInvite: '/:orgId/new-org-invite',
    },
  },

  LoginSelectOrganization: '/organizations',

  OAuthAuthorize: '/oauth/authorize',

  // Where GitHub's install callback lands. Deliberately NOT under /:orgId - the user
  // picks the target organization on this screen, so we cannot know it in advance.
  GithubSetupComplete: '/github/setup-complete',
  // Same reasoning as GithubSetupComplete: the target organization is chosen on this
  // screen, so the route cannot be nested under /:orgId.
  SlackSetupComplete: '/slack/setup-complete',

  Playground: '/playground',

  // Settings panel routes
  Settings: {
    route: '/:orgId/settings',
    children: {
      Personal: '/:orgId/settings/my-profile',
      Organization: '/:orgId/settings/organization-settings',
      UserManagement: '/:orgId/settings/user-management',
      NewUserManagement: '/:orgId/settings/new-user-management',
      SpaceOwnership: '/:orgId/settings/space-ownership',
      Integrations: '/:orgId/settings/integrations',
      // Personal, not organization-wide: any member reaches this, unlike
      // Integrations. Slack's per-user link callback redirects here.
      Notifications: '/:orgId/settings/notifications',
      // Any member: each person connects their own AI client. (#3076)
      Mcp: '/:orgId/settings/mcp',
    },
  },
};

export default paths;
